import { BaseDto, OrderByValue } from '../../core';
import { COUPON_STATUS } from '../../shared';

export class CouponListDto extends BaseDto<CouponListDto> {
  couponStatus?: COUPON_STATUS;
  orderById?: OrderByValue;
  isUsable?: boolean;
  orderByEnded?: OrderByValue;
}
